// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__cCKjY","titleContainer":"Header_titleContainer__1n-yJ","title":"Header_title__1QKkx"};